import { render, staticRenderFns } from "./ImportErrorCard.vue?vue&type=template&id=605fb458&scoped=true&"
import script from "./ImportErrorCard.vue?vue&type=script&lang=js&"
export * from "./ImportErrorCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportErrorCard.vue?vue&type=style&index=0&id=605fb458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605fb458",
  null
  
)

export default component.exports